﻿require('jquery');
global.$ = $;
require('lodash');
require('@uirouter/angularjs');
require('angular-animate');
require('angular-touch');
require('angular-sanitize');
require('angular-cookies');
require('angular-translate');
require('angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files.min.js');
require('angular-translate/dist/angular-translate-storage-cookie/angular-translate-storage-cookie.min.js');
require('angular-translate/dist/angular-translate-storage-local/angular-translate-storage-local.min.js');
require('angular-local-storage/dist/angular-local-storage.min.js');
require('angular-dynamic-locale-secure/tmhdynamiclocale.min.js');
require('angular-modal-service/dst/angular-modal-service.min.js');
require('ng-dialog/js/ngdialog.min.js');
require('q/q.js');
require('crypto-js/aes.js');
require('moment/moment.js');
require('moment-timezone/builds/moment-timezone-with-data.min.js');
require('angular-moment/angular-moment.min.js');
require('angular-grid/dist/angular-grid.min.js');
require('ng-tags-input/build/ng-tags-input.min.js');
require('angular');
require('jquery.easing');
require('../assets/lib/legacy-ui-router-angular/stateEvents.js');
require('../assets/lib/camera-slider/scripts/camera.min.js');
require('../assets/lib/jquery/jquery.date.js');
require('../assets/lib/jquery/jquery.date_es.js');
require('../assets/lib/angular-barcode-generator/barcodeGenerator.js');
require('../assets/lib/ngExDialog/ngExDialog.js');
require('bootstrap');
require('bootstrap-datepicker');
require('@progress/kendo-ui');
require('../assets/lib/vsblockui/vsblockui.js');
require('angular-ui-bootstrap/src/tabindex/tabindex.js');
require('angular-ui-bootstrap/src/paging/paging.js');
require('angular-ui-bootstrap/src/pagination/pagination.js');
require('angular-http-auth');
global.QRCode = require('qrcode-genetator');
require('../assets/lib/angular-qr/angular-qr.js');
require('toastr');
import {Spinner} from 'spin.js';
global.Spinner = Spinner;
require('../ReportViewer/js/telerikReportViewer-10.1.16.615.min.js');

import "../node_modules/angular-grid/dist/angular-grid.min.css";
import "../node_modules/angular-grid/dist/theme-fresh.min.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "../node_modules/toastr/build/toastr.min.css";
import "../node_modules/@progress/kendo-ui/css/web/kendo.common.min.css";
import "../node_modules/@progress/kendo-ui/css/web/kendo.silver.min.css";
import "../node_modules/ng-dialog/css/ngDialog.min.css";
import "../node_modules/ng-dialog/css/ngDialog-theme-default.min.css";
import "../node_modules/ng-tags-input/build/ng-tags-input.min.css";
import "../node_modules/spin.js/spin.css";
import "../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css";
import "../ReportViewer/styles/telerikReportViewer-10.1.16.615.css";
import "../assets/lib/bootstrap/css/bootstrap-add.css";
import "../assets/css/bsp-select/bsp-select.css";
import "../assets/css/layout.css";
import "../assets/css/header-4.css";
import "../assets/css/styles.css";
import "../assets/css/styles-custom.css";
import "../assets/css/table/ui-table.css";
import "../assets/css/side-tools.css";
import "../assets/css/angucomplete/angucomplete-alt.css";
import "../assets/lib/angular-barcode-generator/barcode.css";
import "../assets/lib/camera-slider/css/camera.css";
import "../assets/lib/ngExDialog/ngExDialog.css";

import "../node_modules/angular-ui-bootstrap/dist/ui-bootstrap-csp.css";

(function () {
    'use strict';

    var app = angular.module('app', [
        'ngAnimate',
        'ngSanitize',    
        'app.config',
        'app.common',
        'app.directives',
        'app.services',
        'app.controllers',
        'ngCookies',    
        'ngTouch',
        'ui.router',
        'ui.router.state.events',
        'http-auth-interceptor',
        'LocalStorageModule',
        'pascalprecht.translate',
        'tmh.dynamicLocale',
        'angularGrid',
        'angucomplete-alt',
        'barcodeGenerator',
        'ja.qr',
        'vsblockui',
        'kendo.directives',
        'angularModalService',
        'ngDialog',
        'angularjs-dropdown-multiselect',
        'ui.bootstrap.pagination',
        'ui.pagination.module',
        'angularMoment',
        'ngTagsInput',
        'ngExDialog'
    ]);

    app.config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('authInterceptorService');
    }]);

    app.run([
        'routemediator',
        'datacontext',
        '$rootScope',
        function (routemediator, datacontext, $rootScope) {
            datacontext.prime();
            routemediator.setRoutingHandlers();
            
            $rootScope.IsRefreshToken = false;

            $rootScope.$on('event:auth-loginRequired', function () {
                $rootScope.IsRefreshToken = true;
            });
        }
    ]);

    angular.module('app.config', ['ui.router', 'ngExDialog']);
    angular.module('app.common', []);

    angular.module('app.directives', ['ngSanitize']);

    angular.module('app.services', []);
    angular.module('app.controllers', []);
    angular.module('ui.pagination.module', []);

})();